import React from "react";

function Page1() {
  return (
    <div id="page1" className="page">
      <div className="description">
        <div className="inner">
          <div className="texts">
            <div className="background" />
            <h2>Over</h2>
            <h2 className="outline">184 million gigabytes</h2>
            <h3 className="bottom">of publicly available information are published every minute.</h3>
          </div>
        </div>
      </div>
      <div className="description">
        <div className="inner">
          <div className="texts">
            <div className="background" />
            <p>
              Organizations must be able to <br />turn this disparate data into
            </p>
            <h2 className="outline outline--small">actionable<br />intelligence</h2>
          </div>
        </div>
      </div>
      <div className="description">
        <div className="inner">
          <div className="texts">
            <div className="background" />
            <p>Zignal collects, enriches, and visualizes broad spectrum, high fidelity</p>
            <h2 className="outline outline--small">PAI at scale</h2>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Page1;
